import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloClient,InMemoryCache,ApolloProvider,gql} from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import jwt_decode from 'jwt-decode';
import './assets/scss/master.scss';
import Routing from './route/Routing';
import * as url from './configUrl';
import { createUploadLink } from "apollo-upload-client";
import { ToastContainer } from 'react-toastify';

export function isRefreshNeeded(token) {
  if (!token) {
    return { valid: false, needRefresh: true };
  }

  const decoded = jwt_decode(token);

  if (!decoded) {
    return { valid: false, needRefresh: true };
  }

  if (decoded.exp && Date.now() >= decoded.exp * 1000) {
    return { valid: false, needRefresh: true };
  }
  return { valid: true, needRefresh: false };

}

let client = ApolloClient;


const refreshAuthToken = async () => {
  const refreshToken = localStorage.getItem('refreshtoken')

  const newToken = await client
    .query({
      query: gql`
       query GenerateToken($refreshToken: String!) {
        generateToken(refreshToken: $refreshToken) {
          access_token
          refresh_token
        }
      }
      `,
      variables: { refreshToken: refreshToken },
    })
    .then((res) => {
      const newAccessToken = res.data?.generateToken?.access_token;
      const newRefreshToken = res.data?.generateToken?.refresh_token;
      localStorage.setItem('token', newAccessToken)
      localStorage.setItem('refreshtoken', newRefreshToken)
      return newAccessToken;
    });

  return newToken;
};


const uploadLink = createUploadLink({ 
  // uri: "http://localhost:4000/graphql" 
  uri: process.env.REACT_APP_NODE_ENV ? process.env.REACT_APP_GRAPHQL_URL_LIVE : url.GRAPHQL_URL_LOCAL
})

const apolloAuthLink = setContext(async (request, { headers }) => {
  if (request.operationName !== 'GenerateToken') {
    let token = localStorage.getItem('token');

    const shouldRefresh = isRefreshNeeded(token);

    if (token && shouldRefresh.needRefresh) {
      const refreshPromise = await refreshAuthToken();

      if (shouldRefresh.valid === false) {
        token = await refreshPromise; 
      }
    }

    if (token) {
      return {
        headers: {
          ...headers,
          authorization: `Bearer ${token}`,
        },
      };
    }
    return { headers };
  }

  return { headers };
});


client = new ApolloClient({
  // link: apolloAuthLink.concat(apolloHttpLink),
  link: apolloAuthLink.concat(uploadLink),
  cache: new InMemoryCache({
    addTypename: false
  }),
});


ReactDOM.render(
  <ApolloProvider client={client} >
    <Routing />
    <ToastContainer />
  </ApolloProvider>,
  document.getElementById('root')
);

